export default __webpack_public_path__ + "static/media/CEM-English.dad9f6c7.webp";